import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-instructor',
  templateUrl: './new-instructor.component.html',
  styleUrls: ['./new-instructor.component.scss']
})
export class NewInstructorComponent implements OnInit,OnChanges {
  @Input() instructor:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  
  format:any;
  imageurl:any="";
  imagefile:any=null;

  user:any
  Form: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required])],
    image:["", Validators.compose([Validators.required])],
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if(file.type.indexOf('image')> -1){
        this.imagefile=file;
        this.format = 'image';
      }
      reader.onload = (event) => {
        if(this.format=='image'){
          this.imageurl = (<FileReader>event.target).result;
        }
      }
    }
  }

  
  getUserData(){
    this.adminApi.setLoader(true)
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  getInstructorimage(url : string){
    return  "assets/instructors/"+url
  }


  initForm(){
    this.imageurl=this.getInstructorimage(this.instructor?.image);
    this.Form = this.fb.group({
      name: [this.instructor?.name, Validators.compose([Validators.required])],
      image: ["", !this.instructor?Validators.compose([Validators.required]):null],
    });
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      
      const formData = new FormData();
      if(this.instructor){
        formData.append('id',this.instructor.id);
      }
      formData.append('name', form.value.name);
      formData.append('image', this.imagefile);
      this.adminApi.addInstructor(formData).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          this.imagefile="";
          if(!this.instructor){
            form.reset();
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
